
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Legal from "../pages/legal/page";
import Sitemap from "../pages/sitemap/page";
import Wisdom from "../pages/wisdom/page";
import WisdomHospitality from "../pages/wisdom/hospitality/page";
import WisdomEtiquette from "../pages/wisdom/etiquette/page";
import WisdomButlerSkills from "../pages/wisdom/butler-skills/page";
import WisdomElegance from "../pages/wisdom/elegance/page";
import Services from "../pages/services/page";
import ServicesCorpTraining from "../pages/services/corporate-training/page";
import ServicesPrivateButler from "../pages/services/private-butler/page";
import ServicesMannerCourse from "../pages/services/manner-course/page";
import ServicesConsulting from "../pages/services/consulting/page";
import Media from "../pages/media/page";import RelatedIndexPage from "../pages/related/page";
import RelatedTheButler from "../pages/related/the-butler/page";
import RelatedAssociation from "../pages/related/butler-association/page";
import RelatedAcademy from "../pages/related/butler-academy/page";
import EnRelatedIndexPage from "../pages/en/related/page";
import EnRelatedTheButler from "../pages/en/related/the-butler/page";
import EnRelatedAssociation from "../pages/en/related/butler-association/page";
import EnRelatedAcademy from "../pages/en/related/butler-academy/page";

// Wisdom Articles
import WisdomArticles from "../pages/wisdom/articles/page";
import VipService from "../pages/wisdom/articles/vip-service/page";
import Communication from "../pages/wisdom/articles/communication/page";
import Mindset from "../pages/wisdom/articles/mindset/page";
import TableManners from "../pages/wisdom/articles/table-manners/page";
import DressCode from "../pages/wisdom/articles/dress-code/page";
import SocialEtiquette from "../pages/wisdom/articles/social-etiquette/page";
import DailyRoutine from "../pages/wisdom/articles/daily-routine/page";
import Observation from "../pages/wisdom/articles/observation/page";
import TimeManagement from "../pages/wisdom/articles/time-management/page";
import Posture from "../pages/wisdom/articles/posture/page";
import Speech from "../pages/wisdom/articles/speech/page";
import Organization from "../pages/wisdom/articles/organization/page";
import ColumnPage from "../pages/wisdom/columns/ColumnPage";
import EnglishPage, { englishEntries } from "../pages/en/EnglishPage";
import articles from "../data/articles.json";
import ArticlePage from "../pages/article/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/legal",
    element: <Legal />,
  },
  {
    path: "/sitemap",
    element: <Sitemap />,
  },
  {
    path: "/wisdom",
    element: <Wisdom />,
  },
  {
    path: "/wisdom/hospitality",
    element: <WisdomHospitality />,
  },
  {
    path: "/wisdom/etiquette",
    element: <WisdomEtiquette />,
  },
  {
    path: "/wisdom/butler-skills",
    element: <WisdomButlerSkills />,
  },
  {
    path: "/wisdom/elegance",
    element: <WisdomElegance />,
  },
  {
    path: "/wisdom/articles",
    element: <WisdomArticles />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/corporate-training",
    element: <ServicesCorpTraining />,
  },
  {
    path: "/services/private-butler",
    element: <ServicesPrivateButler />,
  },
  {
    path: "/services/manner-course",
    element: <ServicesMannerCourse />,
  },
  {
    path: "/services/consulting",
    element: <ServicesConsulting />,
  },
  {
    path: "/media",
    element: <Media />,
  },
  // Wisdom Articles
  {
    path: "/wisdom/articles/vip-service",
    element: <VipService />,
  },
  {
    path: "/wisdom/articles/communication",
    element: <Communication />,
  },
  {
    path: "/wisdom/articles/mindset",
    element: <Mindset />,
  },
  {
    path: "/wisdom/articles/table-manners",
    element: <TableManners />,
  },
  {
    path: "/wisdom/articles/dress-code",
    element: <DressCode />,
  },
  {
    path: "/wisdom/articles/social-etiquette",
    element: <SocialEtiquette />,
  },
  {
    path: "/wisdom/articles/daily-routine",
    element: <DailyRoutine />,
  },
  {
    path: "/wisdom/articles/observation",
    element: <Observation />,
  },
  {
    path: "/wisdom/articles/time-management",
    element: <TimeManagement />,
  },
  {
    path: "/wisdom/articles/posture",
    element: <Posture />,
  },
  {
    path: "/wisdom/articles/speech",
    element: <Speech />,
  },
  {
    path: "/wisdom/articles/organization",
    element: <Organization />,
  },
  {
    path: "/wisdom/columns/:slug",
    element: <ColumnPage />,
  },
  { path: "/related", element: <RelatedIndexPage /> },
  { path: "/related/the-butler", element: <RelatedTheButler /> },
  { path: "/related/butler-association", element: <RelatedAssociation /> },
  { path: "/related/butler-academy", element: <RelatedAcademy /> },
  { path: "/en/related", element: <EnRelatedIndexPage /> },
  { path: "/en/related/the-butler", element: <EnRelatedTheButler /> },
  { path: "/en/related/butler-association", element: <EnRelatedAssociation /> },
  { path: "/en/related/butler-academy", element: <EnRelatedAcademy /> },  ...englishEntries.map((entry) => ({
    path: entry.route === '/' ? '/en' : `/en${entry.route}`,
    element: <EnglishPage route={entry.route} />,
  })),
  ...articles.map((a: { route: string }) => ({
    path: a.route,
    element: <ArticlePage />,
  })),
  ...articles.filter((a: { en?: unknown }) => Boolean(a.en)).map((a: { route: string }) => ({
    path: a.route === '/' ? '/en' : '/en' + a.route,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
